import { sortByPosition } from '@/utils/category';

export function trimmCategories(tempCategories, allKeyword = 'Όλα') {
  const trimmedArray = tempCategories.map(category => ({
    _id: category._id,
    text: category.name,
    slugAscii: category.fullSlug,
    fullSlug: category.fullSlug,
    slug: category.slug,
    hasIcon: true,
    icon: category.icon,
    selectedIcon: category?.selectedIcon && category.selectedIcon,
    top_banners: category?.top_banners && category?.top_banners,
    side_banners: category?.side_banners && category?.side_banners,
    isFeatured: category.isFeatured,
    isOffer: category?.isOffer ?? null,
    position: category?.position,
    subcategories: sortByPosition(
      category.subCategories.map(subcategory => ({
        _id: subcategory._id,
        text: subcategory.name,
        slugAscii: subcategory.fullSlug,
        fullSlug: subcategory.fullSlug,
        slug: subcategory.slug,
        position: subcategory?.position,
      }))
    ),
  }));
  const featuredCategories = [];
  const normalCategories = [];
  const offerCategories = [];

  trimmedArray.map(category => {
    const allSubcategory = { text: allKeyword, slugAscii: '' };

    category.subcategories !== undefined
      ? category.subcategories.unshift(allSubcategory)
      : (category.subcategories = [allSubcategory]);

    if (category?.isOffer) {
      offerCategories.push(category);
    } else {
      if (!category.isFeatured) {
        normalCategories.push(category);
      }
      if (category.isFeatured) {
        featuredCategories.push(category);
      }
    }
  });
  return { normalCategories, featuredCategories, offerCategories };
}

export function checkValuesExist(valueToCheck, targetArray) {
  // Use every() method to check if every value in valuesToCheck exists in targetArray
  const allExist = targetArray.includes(valueToCheck);

  return allExist;
}

export function createOfferCategories(categoriesFromFile, displayStrategies) {
  const { normalCategories, featuredCategories, offerCategories } = trimmCategories(categoriesFromFile);
  let allCategories = [];
  const sortedNormalCategories = sortByPosition(normalCategories);
  const sortedFeaturedCategories = sortByPosition(featuredCategories);
  const sortedOfferCategories = sortByPosition(offerCategories);

  const hasOfferCategories = checkValuesExist('OFFER_CATEGORY_TREE', displayStrategies);
  const hasDefaultCategories = checkValuesExist('DEFAULT_CATEGORY_TREE', displayStrategies);
  if (!displayStrategies) {
    return [...sortedFeaturedCategories, ...sortedNormalCategories];
  }
  if (hasOfferCategories && hasDefaultCategories) {
    allCategories = [...sortedOfferCategories, ...sortedFeaturedCategories, ...sortedNormalCategories];
  } else if (hasOfferCategories && !hasDefaultCategories) {
    allCategories = [...sortedOfferCategories];
  } else if (!hasOfferCategories && hasDefaultCategories) {
    allCategories = [...sortedFeaturedCategories, ...sortedNormalCategories];
  } else {
    allCategories = [...sortedFeaturedCategories, ...sortedNormalCategories];
  }
  return allCategories;
}
